export default function TrustStrip() {
  return (
    <section className="py-8 md:py-10 px-6 md:px-10 bg-background-50 border-b border-background-200/70">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col sm:flex-row items-center justify-center gap-6 md:gap-12 text-center">
          <div className="flex items-center gap-2">
            <i className="ri-checkbox-circle-line text-accent-500 text-lg w-5 h-5 flex items-center justify-center"></i>
            <span className="text-sm text-foreground-600">Updated Daily</span>
          </div>
          <div className="flex items-center gap-2">
            <i className="ri-checkbox-circle-line text-accent-500 text-lg w-5 h-5 flex items-center justify-center"></i>
            <span className="text-sm text-foreground-600">Structured Comparison Data</span>
          </div>
          <div className="flex items-center gap-2">
            <i className="ri-checkbox-circle-line text-accent-500 text-lg w-5 h-5 flex items-center justify-center"></i>
            <span className="text-sm text-foreground-600">Beginner-Friendly Guides</span>
          </div>
          <p className="text-xs text-foreground-400">
            Trusted by users exploring spreadsheet-based shopping systems worldwide
          </p>
        </div>
      </div>
    </section>
  );
}